export const authHighlights = [
  {
    title: 'Use AI to auto fill visa forms',
  },
  {
    title: 'Automate appointments, translation and more',
  },
  {
    title: 'Get a ready to submit visa package',
  },
  {
    title: 'Have AI guide you every step of the way',
  },
];

export const initialSignupForm = {
  countryCode: '+20',
  phoneLocalNumber: '',
  otpCode: '',
  email: '',
  password: '',
};

export const initialLoginForm = {
  email: '',
  password: '',
};

export const initialPasswordResetForm = {
  email: '',
  otpCode: '',
  password: '',
};
